<template>
  <div>
    <loading :showLoading="load" />
    <div class="Create alignment EditClientConfiguration">
      
      <v-form ref="form">
        
        <v-flex xs12 sm12
        >
          <div style="width: 100%; overflow:auto;">
            <div style="width:50%; float:left;">
              <h3 v-if="edit" class="styleHeader" style="margin-bottom: 31px"> {{ $t("ClientConfiguration.EditTitle") }}  </h3>
              <h3 v-else class="styleHeader" style="margin-bottom: 31px"> {{ $t("ClientConfiguration.AddTitle") }}  </h3> 
            </div>

            <div style="width:50%; float:right;">
                <div style="width: 100%; overflow:auto;">
                  <div style="width:auto; float:right; margin-right:4%;">
                    <h4 style="text-align: left; font-size:14px; margin-bottom: 5px"> 
                      <i
                        class="far fa-clock iconstyle"
                        style="margin-right: 1%"
                      ></i> &nbsp;
                      {{ $t("grid.Columns.LastModified") }}: {{this.lastModified}}
                    </h4>

                    <h4 style="text-align: left; font-size:14px;">
                      <i class="fas fa-user-edit iconstyle"></i> &nbsp;
                      {{ $t("grid.Columns.ModifiedUser") }}: {{this.modifiedUser}}
                    </h4> 
                  </div>
              </div>
            </div>       
          </div>

         <!--form modifica-->
          <v-card class="styleDataTable border">
            <template>              

              <v-row>
                <v-col>
              <v-text-field 
                v-model="ClientCode" 
                label="ClientCode"
                :counter="20"
                :readonly="isEdit"
                :disabled="isEdit"
                :error-messages="ClientCodeError"
                @input="$v.ClientCode.$touch()"
                @blur="$v.ClientCode.$touch()">
              </v-text-field>              
                </v-col>
              </v-row>
              <v-row>
                <v-col>
              <v-select
                v-model="TrafficType"
                :items="trafficTypes"
                item-value="id"
                item-text="value"
                height="30"
                multiple
                required
                :label="$t('SearchItem.TrafficType')"                
              ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
              <v-text-field 
                v-model="OutFileName" 
                label="OutFileName"
                required
                :error-messages="OutFileNameError"
                @input="$v.OutFileName.$touch()"
                @blur="$v.OutFileName.$touch()">
              </v-text-field>
                </v-col>
              </v-row>              
              <v-row>
                <v-col cols="1" class="maxwidthcolumn">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y                  
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateFormatted"
                      :label="$t('ClientConfiguration.LastProcessingDate')"
                      hint="MM/DD/YYYY"
                      persistent-hint
                      v-bind="attrs"
                      @blur="date = parseDate(dateFormatted);$v.OutFileName.$touch()"
                      v-on="on"
                      :error-messages="DateFormattedError"
                      @input="$v.dateFormatted.$touch()"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>                
                </v-col>
                <v-col cols="1" class="maxwidthcolumn">
                  <v-menu
                    ref="menu"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="time"
                    transition="scale-transition"
                    offset-y
                    max-width="250px"
                    min-width="250px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="time"
                        v-bind="attrs"
                        v-on="on"
                        required
                        :error-messages="TimeError"
                        @input="$v.time.$touch()"
                        @blur="$v.time.$touch()"
                        class="timepicker">
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu2"
                      v-model="time"
                      full-width
                      @click:minute="$refs.menu.save(time)"
                      format="24hr"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                <v-checkbox
                    v-model="active"
                    :label="$t('ClientConfiguration.Active')"                
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                <v-checkbox
                    v-model="dachser"
                    :label="$t('ClientConfiguration.Dachser')"                
                  ></v-checkbox>
                </v-col>
              </v-row>
            </template>
          </v-card>
          <v-btn
            class="white--text styleButtonTop styleAlignementSaveButton border"
            @click="submit()"
            color="black">
            <v-icon left>fas fa-check-circle</v-icon> 
            {{ $t("SearchMenu.Button.Save") }}
          </v-btn>
          <v-btn class="styleButtonTop border" @click="back()">
            <v-icon left>fas fa-times-circle</v-icon>
            {{ $t("SearchMenu.Button.Cancel") }}
          </v-btn>
        </v-flex>
      </v-form>

      <!-- <error :showError="showErr" :textError="textErr"/>        -->
     <v-snackbar v-model="showErr" color="error">
      {{ textErr }}
      <v-btn
        color="white"
        text
        @click="showErr=false">
        {{ $t("Misc.Close") }}
      </v-btn>
    </v-snackbar>
       
    </div>
  </div>
</template>
<script>
import loading from "../../components/loadingComponent.vue";
import router from "@/router/index.js";
import { required, maxLength } from "vuelidate/lib/validators";
import { Trans } from "@/plugins/Translation";
import PODApi from "../../api/PODPortal/api.js";
import moment from 'moment';

export default {
   components: { loading },
  validations: { 
    ClientCode: { required },
    TrafficType: { required },
    OutFileName: { required },
    dateFormatted: { required },
    time: { required }
  },
  data: vm => ({
    
      ManageClientsFunction: process.env.VUE_APP_MANAGE_CLIENTS,
      load: false,
      showErr: false,
      textErr: "",      
      ClientCode: "",
      TrafficType: "",
      OutFileName: "",
      active: false,
      dachser: false,
      isEdit: false,
      menu1: false,      
      date: "",
      time: null,
      menu2: false,
      modal2: false,
      lastModified: "",
      modifiedUser: "",


      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)), 
      trafficTypes: [
      { id: "I", value: "Import"},
      { id: "E", value: "Export"},
      { id: "N", value: "Nazionale"}
    ]
    
  }),

computed: {
    edit() {
      return this.$route.params.Id > 0
    },
    ClientCodeError() {
      const errors = [];
      if (!this.$v.ClientCode.$dirty) return errors;
      !this.$v.ClientCode.required && errors.push(this.currentLanguage.t("Validations.CampoObbligatorio"));
      return errors;
    },

    TrafficTypeError() {
      const errors = [];
      if (!this.$v.TrafficType.$dirty) return errors;
      !this.$v.TrafficType.required && errors.push(this.currentLanguage.t("Validations.CampoObbligatorio"));
      return errors;
    },

    OutFileNameError() {
      const errors = [];
      if (!this.$v.OutFileName.$dirty) return errors;
      !this.$v.OutFileName.required && errors.push(this.currentLanguage.t("Validations.CampoObbligatorio"));
      return errors;
    },

    DateFormattedError() {
      const errors = [];
      if (!this.$v.dateFormatted.$dirty) return errors;
      !this.$v.dateFormatted.required && errors.push(this.currentLanguage.t("Validations.CampoObbligatorio"));
      return errors;
    },

    TimeError() {
      const errors = [];
      if (!this.$v.time.$dirty) return errors;
      !this.$v.time.required && errors.push(this.currentLanguage.t("Validations.CampoObbligatorio"));
      return errors;
    },

    currentLanguage() {
      return Trans.i18n;
    }, 

    computedDateFormatted () {
      //console.log("date computed", this.date);
        return this.formatDate(this.date)
      },
},


    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },

  created() {

    
    if (!this.hasPermission()) {
      router.push({name: "Home"});
    }
    
    //this.menuStart();
    this.setDefaultDate();
    this.showErr=false;
    const id = this.$route.params.Id;
    if(id) {
      this.isEdit=true;

      PODApi.GetClientConfiguration(id)     
        .then(response => {
          this.ClientCode=response.data.clientCode;
          this.TrafficType=response.data.trafficType ? response.data.trafficType.split("") : "";
          this.OutFileName=response.data.outFileName;
          this.active = response.data.status;
          this.dachser = response.data.dachser;
          this.modifiedUser = response.data.modifiedUser ? response.data.modifiedUser : "";
          if(response.data.lastModified)
            this.lastModified = moment.utc(response.data.lastModified).format('DD/MM/YYYY HH:mm:ss');
          
          if (!response.data.lastProcessingDate) {
            this.setDefaultDate();
          }
          else {
            const [year, month, day] = response.data.lastProcessingDate.split('-')
            this.date = `${year}-${month}-${day.split("T")[0]}`;
            const [hour, minute, second] = response.data.lastProcessingDate.split("T")[1].split(":");
            this.time = `${hour}:${minute}`;
            //console.log("date loaded", this.date, this.time);
          }
        }).catch(e=>{
          this.showErr=true;
          this.textErr=e.response.data;
          this.load=false;
        });
    }
    else {
      this.isEdit=false;
    }
  },

methods: {

  setDefaultDate() {
    this.time="00:00";
    this.date=new Date().toISOString().substr(0, 10);
  },

  async hasPermission() {
    let result = await this.$GAUserAuth.canRead(this.ManageClientsFunction);
    return result;
  },

  back() {
      router.push({name: "ConfigIndex"});
    },

    submit() {
      this.$v.$touch();
      this.load = true;

      const id = this.$route.params.Id;

      if( 
        this.$v.ClientCode.$error ||
        this.$v.TrafficType.$error ||
        this.$v.OutFileName.$error ||
        this.$v.dateFormatted.$error ||
        this.$v.time.$error ||
        !this.$refs.form.validate() 
      ) {
        this.load = false;
        return;
      }
      

      let clientConfiguration = {
        Id: id,
        ClientCode: this.ClientCode,
        TrafficType: this.TrafficType.join(""),
        OutFileName: this.OutFileName,
        CreationUser: this.$GAUserAuth.user.username,
        Status: this.active,
        LastProcessingDate_s: this.date + " " + this.time,
        Dachser: this.dachser
      };
      
      PODApi.AddClientConfigurationInternal(clientConfiguration).then(response =>{
        router.push({name: "ConfigIndex"});
      }).catch(e=>{          
          this.showErr=true;
          this.textErr=Trans.i18n.t(e.response.data);
          this.load=false;
      }).finally(()=>{
        this.load=false;
      })

    },

    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
}

}
</script>